import { axios } from '@/services/axios';

const getAllTrunks = async (companyId, accountScope, platformId) => {
    const res = await axios.get(
        platformId
            ? `/Trunks/${companyId}?PlatformID=${platformId}`
            : `/Trunks/${companyId}`,
        {
            headers: {
                'X-RequestScope': accountScope,
            },
        },
    );
    return res.data || [];
};

export default getAllTrunks;
